import { render, staticRenderFns } from "./element-input-block.vue?vue&type=template&id=b4bf4f10&scoped=true"
import script from "./element-input-block.vue?vue&type=script&lang=js"
export * from "./element-input-block.vue?vue&type=script&lang=js"
import style0 from "./element-input-block.vue?vue&type=style&index=0&id=b4bf4f10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bf4f10",
  null
  
)

export default component.exports